"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kycConfigLevelShape = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var kycConfigLevelShape = exports.kycConfigLevelShape = {
  type: _propTypes["default"].string,
  levels: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    level: _propTypes["default"].number,
    button: _propTypes["default"].string,
    label: _propTypes["default"].string,
    description: _propTypes["default"].shape({
      benefits: _propTypes["default"].array,
      requirements: _propTypes["default"].string
    }),
    verifiedMessage: _propTypes["default"].string,
    underReviewMessage: _propTypes["default"].string,
    form: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string,
      type: _propTypes["default"].string
    }))
  }))
};